import { useEffect, useState } from 'react';

/** Reactive media query. Drives the single-codebase desktop/mobile split in AppFrame. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/**
 * App shell desktop navigation — sidebar vs bottom nav.
 * Matches DESIGN-SYSTEM / SCREEN-COMPOSITION: 900px shell boundary.
 */
export const useIsDesktop = () => useMediaQuery('(min-width: 900px)');

/**
 * Comfortable master-detail layouts (inline detail beside list).
 * List stays full-width until an item is selected (see `.make-split--has-selection`).
 */
export const useIsWide = () => useMediaQuery('(min-width: 1024px)');
